import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { KundorderTyp, RaskRoller } from "~app/common/models/constants";
import { CkleverantorComponent } from "~app/features/forsaljning/ckleverator/ckleverantor.component";
import { DetailsComponent } from "~app/features/forsaljning/handelssortiment/details/details.component";
import { HandelssortimentComponent } from "~app/features/forsaljning/handelssortiment/handelssortiment.component";
import { KundComponent } from "~app/features/forsaljning/kund/kund.component";
import { CopyLeverantorsorderComponent } from "~app/features/forsaljning/leverantorsorder/copy-order/copy-leverantorsorder.component";
import { MottagningsplatsDetaljerComponent } from "~app/features/forsaljning/mottagningsplats/mottagningsplats-detaljer/mottagningsplats-detaljer.component";
import { SearchMottagningsplatsComponent } from "~app/features/forsaljning/mottagningsplats/search/search-mottagningsplats.component";
import { ProduktDetailComponent } from "~app/features/forsaljning/produkt/produkt-detail/produkt-detail.component";
import { ProduktSearchComponent } from "~app/features/forsaljning/produkt/produkt-search/produkt-search.component";
import { TerminalorderDetailsComponent } from "~app/features/forsaljning/terminalorder/terminalorder-details/terminalorder-details.component";
import { TerminalorderComponent } from "~app/features/forsaljning/terminalorder/terminalorder.component";
import { KundorderDetailsComponent } from "../features/forsaljning/kundorder/kundorder-details/kundorder-details.component";
import { KundorderComponent } from "../features/forsaljning/kundorder/kundorder.component";
import { LeverantorsorderDetailsComponent } from "../features/forsaljning/leverantorsorder/leverantorsorder-details/leverantorsorder-details.component";
import { LeverantorsorderComponent } from "../features/forsaljning/leverantorsorder/leverantorsorder.component";
import { CopyOrderComponent } from "../features/forsaljning/order/copy-order/copy-order.component";

export const forsaljningRoutes: Routes = [
    {
        path: "terminalorder",
        title: "Terminalorder",
        children: [
            {
                path: "",
                component: TerminalorderComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Kundhantera],
                    volatileState: "terminalorder"
                }
            },
            {
                path: ":id",
                children: [
                    {
                        title: "Terminalorder Detaljer",
                        path: "",
                        component: TerminalorderDetailsComponent,
                        canDeactivate: [DirtyGuard],
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera],
                            volatileState: "terminalorder"
                        }
                    },
                    {
                        path: "copy",
                        title: "Kopiera Terminalorder",
                        component: CopyOrderComponent,
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera],
                            volatileState: "terminalorder",
                            typ: KundorderTyp.Terminalorder
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "produkt",
        title: "Produkt",
        children: [
            {
                path: "",
                component: ProduktSearchComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktadministrera],
                    volatileState: "produkt"
                }
            },
            {
                path: ":id",
                title: "Detaljer",
                children:[
                    {
                        path:"",
                        redirectTo: "basdata",
                        pathMatch: "full"
                    },
                    {
                        path:":tab",
                        canDeactivate: [DirtyGuard],
                        component: ProduktDetailComponent,
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Produktadministrera],
                            skipEnvironmentTitleStrategyForRoute: true
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "mottagningsplats",
        title: "Mottagningsplats",
        children: [
            {
                path: "",
                component: SearchMottagningsplatsComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [
                        RaskRoller.role.Kundhantera,
                        RaskRoller.role.Administrera
                    ]
                }
            },
            {
                path: ":typ/:id",
                title: "Detaljer",
                canDeactivate: [DirtyGuard],
                component: MottagningsplatsDetaljerComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [
                        RaskRoller.role.Kundhantera,
                        RaskRoller.role.Administrera
                    ]
                }
            }
        ]
    },
    {
        path: "mottagningsplats-new",
        redirectTo: "mottagningsplats",
        pathMatch: "full"
    },
    {
        path: "mottagningsplats/sverige-new/:id",
        redirectTo: "mottagningsplats/svensk/:id"
    },
    {
        path: "mottagningsplats/utlandsk-new/:id",
        redirectTo: "mottagningsplats/utlandsk/:id"
    },
    {
        path: "handelssortiment",
        title: "Handelssortiment",
        children: [
            {
                path: "",
                component: HandelssortimentComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktadministrera]
                }
            },
            {
                path: ":id",
                title: "Detaljer",
                canDeactivate: [DirtyGuard],
                component: DetailsComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktadministrera]
                }
            }
        ]
    },
    {
        path: "kundorder",
        title: "Kundorder",
        children: [
            {
                path: "",
                component: KundorderComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Kundhantera]
                }
            },
            {
                path: ":id",
                children: [
                    {
                        path: "",
                        canDeactivate: [DirtyGuard],
                        component: KundorderDetailsComponent,
                        title: "Kundorder Detaljer",
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera]
                        }
                    },
                    {
                        path: "copy",
                        title: "Kopiera Kundorder",
                        component: CopyOrderComponent,
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera],
                            typ: KundorderTyp.Kundorder
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "leverantorsorder",
        title: "Leverantörsorder",
        children: [
            {
                path: "",
                component: LeverantorsorderComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Kundhantera]
                }
            },
            {
                path: ":id",
                children: [
                    {
                        path: "",
                        canDeactivate: [DirtyGuard],
                        component: LeverantorsorderDetailsComponent,
                        title: "Leverantörsorder Detaljer",
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera]
                        }
                    },
                    {
                        path: "copy",
                        title: "Kopiera Leverantorsorder",
                        component: CopyLeverantorsorderComponent,
                        data: {
                            requiredRoles: [RaskRoller.role.Titta],
                            editRoles: [RaskRoller.role.Kundhantera]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "kund",
        title: "Kunder",
        component: KundComponent,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Kundhantera]
        }
    },
    {
        path: "ckleverantor",
        title: "CK Leverantörer",
        component: CkleverantorComponent,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Kundhantera]
        }
    }
];
